module.exports = __webpack_public_path__ + "static/traffic-up-robesnmore-be8ab6d429093a6e87b221f84b928c2e.png";